package com.fireavert.react.shared.error

import emotion.css.ClassName
import web.cssom.*

object ErrorStyles {

    val errorDialogMessage = ClassName {
        display = Display.Companion.flex
        justifyContent = JustifyContent.Companion.center
        alignItems = AlignItems.Companion.center
        height = 100.pct
        color = NamedColor.Companion.red
        fontWeight = FontWeight.Companion.bold
        maxWidth = 100.pct
        overflowX = Auto.Companion.auto
        marginTop = 15.px
    }
}